import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { blogs } from '../utils/blogData';

export default function BlogIndexPage() {
    return (
        <div className="py-20 bg-gray-50 min-h-screen">
            <Helmet>
                <title>EV Charging Blog & Guides | PeerChargeEV</title>
                <meta name="description" content="Read the latest news, guides, and tips on EV charging in India, peer-to-peer sharing, and earning money from your home charger with PeerChargeEV." />
            </Helmet>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                        PeerChargeEV Blog
                    </h1>
                    <p className="mt-4 text-xl text-gray-500">
                        Guides, tips, and insights on EV charging across India.
                    </p>
                </div>

                <div className="grid gap-12 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
                    {blogs.map((post) => (
                        <div key={post.id} className="flex flex-col rounded-2xl shadow-lg overflow-hidden bg-white border border-gray-100 hover:shadow-xl transition-shadow duration-300">
                            <div className="flex-1 p-8 flex flex-col justify-between">
                                <div className="flex-1">
                                    <Link to={`/${post.slug}`} className="block mt-2">
                                        <h3 className="text-2xl font-bold text-gray-900 hover:text-green-600 transition-colors duration-200">
                                            {post.title}
                                        </h3>
                                        <p className="mt-4 text-base text-gray-500 line-clamp-4">
                                            {post.metaDescription}
                                        </p>
                                    </Link>
                                </div>
                                <div className="mt-8 flex items-center">
                                    <div className="flex-shrink-0">
                                        <div className="h-10 w-10 rounded-full bg-green-100 flex items-center justify-center">
                                            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="ml-3">
                                        <p className="text-sm font-medium text-gray-900">
                                            PeerChargeEV Team
                                        </p>
                                        <div className="flex space-x-1 text-sm text-gray-500">
                                            <span>2026 Guide</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
